import { FaTools, FaShieldAlt, FaHammer } from "react-icons/fa";

const whyChooseUs = {
  sub: "Why Choose Us",
  heading: "Exquisite Woodwork Craftsmanship to Elevate Your Space",
  content: "At WoodCrafters, we're dedicated to enhancing the aesthetics and security of your home with our artisanal windows and doors.",
  points: [
    {
      id: 1,
      icon: <FaTools />, // Tools icon
      title: "Bespoke Solutions",
      content: "We offer tailored window and door solutions to meet your unique needs, ensuring seamless integration with your home's style.",
    },
    {
      id: 2,
      icon: <FaShieldAlt />, // Shield icon
      title: "Enhanced Security",
      content: "With our top-of-the-line security features, we provide unparalleled protection for your home, ensuring your peace of mind.",
    },
    {
      id: 3,
      icon: <FaHammer />, // Hammer icon
      title: "Professional Craftsmanship",
      content: "Our skilled artisans ensure meticulous installation of your windows and doors, ensuring superior performance and longevity.",
    },
  ],
};

export default whyChooseUs;